import { useEffect, useState } from "react";

// Given an image url shown with `background-size: contain` inside a fixed
// boxW×boxH box, return the letterbox padding {padX, padY} between the box edge
// and the actual rendered image edge. Used to anchor captions to the image
// itself instead of the box (e.g. a 16:6 image leaves large top/bottom bars).
export default function useContainInset(url, boxW, boxH) {
  const [inset, setInset] = useState({ padX: 0, padY: 0 });

  useEffect(() => {
    if (!url) {
      setInset({ padX: 0, padY: 0 });
      return;
    }
    let alive = true;
    const img = new Image();
    img.onload = () => {
      if (!alive) return;
      const { naturalWidth: nw, naturalHeight: nh } = img;
      if (!nw || !nh) return;
      const boxAspect = boxW / boxH;
      const imgAspect = nw / nh;
      if (imgAspect > boxAspect) {
        // wider than box: full width, letterbox top/bottom
        setInset({ padX: 0, padY: (boxH - boxW / imgAspect) / 2 });
      } else {
        // taller than box: full height, pillarbox left/right
        setInset({ padX: (boxW - boxH * imgAspect) / 2, padY: 0 });
      }
    };
    img.src = url;
    return () => {
      alive = false;
    };
  }, [url, boxW, boxH]);

  return inset;
}
